import moment from 'moment';

// API timestamps are UTC ISO strings. Older timezone-less DATETIME strings
// also represent UTC; never interpret them in the browser's local timezone.
export function paymentDateKst(value) {
  if (!value) return '—';
  const date = moment.utc(value, moment.ISO_8601, true);
  return date.isValid() ? date.utcOffset(540).format('YYYY-MM-DD') : '—';
}
